import {
  Button,
  Card,
  CardBody,
  Heading,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { useCustomCategories } from "../context/CustomCatgoriesContext";
import { useSavingGoals } from "../context/SavingGoalsContext";
import { useTransactions } from "../context/TransactionsContext";
import { SavingGoalBoxes } from "./SavingGoalBoxes";

export const SavingGoalsProgress = () => {
  const { transactions } = useTransactions();
  const [confettiShownFor, setConfettiShownFor] = useState<string[]>([]);
  const { categories: customCategories } = useCustomCategories();
  const { savingGoals, removeGoal } = useSavingGoals();
  const [isOpen, setIsOpen] = useState(false);

  const savings = transactions.filter((t) => t.type === "saving");

  const validCategoryValues = customCategories.map((c) => c.value);

  const filteredGoals = savingGoals.filter((goal) =>
    validCategoryValues.includes(goal.category)
  );

  const getSavedForGoal = (goal: (typeof savingGoals)[0]) =>
    savings
      .filter((t) => t.savingGoalId === goal.id)
      .reduce((sum, t) => sum + t.amount, 0);

  if (filteredGoals.length === 0) return null;

  return (
    <Card.Root mt={6} shadow="sm" padding={0}>
      <CardBody padding={0}>
        <HStack justify="space-between" p={3}>
          <Heading size="md">Sparziele</Heading>
          <Button
            size="sm"
            variant="ghost"
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? "Weniger anzeigen" : "Sparziele anzeigen"}
          >
            {/* @ts-ignore */}
            {isOpen ? <IoChevronUp /> : <IoChevronDown />}
          </Button>
        </HStack>
        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              style={{ overflow: "hidden" }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <VStack spaceY={5} align="stretch" p={4}>
                {filteredGoals.map((goal) => {
                  const saved = getSavedForGoal(goal);
                  const goalReached = saved >= goal.amount;
                  const shouldShowConfetti =
                    goalReached &&
                    isOpen &&
                    !confettiShownFor.includes(goal.id);

                  return (
                    <SavingGoalBoxes
                      key={goal.id}
                      goal={goal}
                      saved={saved}
                      onRemove={removeGoal}
                      showConfetti={shouldShowConfetti}
                      markConfettiShown={() => {
                        setConfettiShownFor((prev) => [...prev, goal.id]);
                      }}
                    />
                  );
                })}
              </VStack>
            </motion.div>
          )}
        </AnimatePresence>
      </CardBody>
    </Card.Root>
  );
};
